import gql from 'graphql-tag'

export const getSpacesOverviewQuery = gql`
    query getSpacesOverview($eventSlug: EventID!, $type: SpaceTypeEnum, $search: String) {
        event(id: $eventSlug) {
            spaces(first: 499, type: $type, search: $search) {
                edges {
                    node {
                        id
                        slug
                        name
                        type
                        published
                        timetableOrder
                    }
                }
            }
        }
    }
`
